"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparePopupAlpha = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const ComparePopupContainer_1 = tslib_1.__importDefault(require("../../../containers/ComparePopupContainer"));
const ProductSelector_1 = require("../../../redux/product/selectors/ProductSelector");
const common_components_1 = require("@as-react/common-components");
const ComparePopupAlpha = ({ isStickyBar }) => {
    const productState = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductState)());
    const { feature_toggles: { product_compare }, } = (0, common_components_1.useAemConfig)();
    const showPopup = product_compare &&
        ((productState.available && !productState.outOfStock && !productState.selectedColorOutOfstock) ||
            (productState.available && productState.outOfStock));
    return showPopup ? (0, jsx_runtime_1.jsx)(ComparePopupContainer_1.default, { isStickyBar: isStickyBar }) : null;
};
exports.ComparePopupAlpha = ComparePopupAlpha;
